#import "../fragments/activity-transcript-and-summary-fragment.graphql"

query GetActivityTranscriptAndSummary($activityId: ID!) {
    activity(id: $activityId) {
        ...ActivityTranscriptAndSummaryFragment
    }
}
